export default "__VITE_ASSET__Bi9rudhB__"